export default "__VITE_ASSET__DPAlBxfg__"